import Translate from "../../Translate"

export const OptionalIndicator = () => {
  return (
    <span className="oj-optional-indicator" aria-hidden>
      <Translate id="optionalLabelText" />
    </span>
  )
}

export default OptionalIndicator
